import type { Action } from '../typings/reducers';

type UserBrand = { _id: string } & Record<string, unknown>;
type UserBrandsState = Record<string, UserBrand>;

export default function (state: UserBrandsState = {}, action: Action): UserBrandsState {
  switch (action.type) {
    case 'SET_USER_BRANDS': {
      const values = action.payload as UserBrand[];
      const brands: Record<string, UserBrand> = {};
      values.forEach((val) => (brands[val._id] = val));

      return { ...state, ...brands };
    }
    case 'SET_USER_BRAND': {
      const values = action.payload as UserBrand;

      return { ...state, [values._id]: values };
    }
    case 'SET_USER_BRAND_IMAGE': {
      const { img, userBrandId, type } = action.payload as {
        img: unknown;
        userBrandId: string;
        type: string;
      };

      return {
        ...state,
        [userBrandId]: { ...state[userBrandId], [type]: img }
      };
    }
    case 'REMOVE_USER_BRAND': {
      return { ...state, [action.payload as string]: undefined };
    }
    case 'SET_USER_BRAND_VALUE': {
      const { userBrandId, key, value } = action.payload as {
        userBrandId: string;
        key: string;
        value: unknown;
      };

      return {
        ...state,
        [userBrandId]: { ...state[userBrandId], [key]: value }
      };
    }
    default:
      return state;
  }
}
